import { NgClass, UpperCasePipe } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	output,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MarkdownModule } from 'ngx-markdown';

import { SheetModule } from '@valk-nx/components/ui-sheet/src';
import {
	TooltipComponent,
	TooltipContentDirective,
} from '@valk-nx/components/ui-tooltip/src';
import { ReceiptSummaryItemComponent } from '@valk-nx/compositions/ui-receipt-summary/src/lib/components/item/item.component';
import {
	Item,
	ItemWithExtras,
	PromotionInterface,
	SpecifiedTaxes,
} from '@valk-nx/compositions/ui-receipt-summary/src/lib/receipt-summary.interface';
import { PercentagePipe } from '@valk-nx/core/lib/pipes/percentage/percentage.pipe';
import { PricePipe } from '@valk-nx/core/lib/pipes/price/price.pipe';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-receipt-summary`,
	templateUrl: './receipt-summary.component.html',
	imports: [
		AngularSvgIconModule,
		NgClass,
		UpperCasePipe,
		TooltipComponent,
		TooltipContentDirective,
		SheetModule,
		ReceiptSummaryItemComponent,
		TranslatePipe,
		PricePipe,
		MarkdownModule,
		PercentagePipe,
	],
})
export class ReceiptSummaryComponent {
	receiptDescription = input('');
	currency = input('EUR');
	itemsDescription = input('');
	items = input<(Item | ItemWithExtras)[]>([]);
	tax = input<SpecifiedTaxes | number>(0);
	subTotal = input(0);
	alreadyPaid = input(0);
	loyalToPay = input(0);
	total = input<number | null>(null);
	totalVat = input(0);
	amountToPay = input<number | null>(null);
	toComply = input<number | null>(null);
	hasConditions = input(false);
	conditions = input('');
	loyalToEarn = input(0);
	payOnArrival = input(false);
	paymentOption = input<string | undefined>(undefined);
	showLoyal = input(true);
	promotion = input<PromotionInterface | undefined>(undefined);

	getConditionsEmit = output<boolean>();

	hasExtras = computed(() =>
		this.items().some(
			(item) =>
				('extras' in item &&
					Array.isArray(item.extras) &&
					item.extras.length > 0) ||
				('upgrade' in item && !!item.upgrade),
		),
	);

	specifiedTaxes = computed(() => {
		const tax = this.tax();
		return typeof tax === 'object' ? tax : undefined;
	});

	unspecifiedTaxes = computed(() => {
		const tax = this.tax();
		return typeof tax === 'object' ? undefined : tax;
	});

	getConditions() {
		this.getConditionsEmit.emit(true);
	}
}
